import React, {useCallback, useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {getUserDoubleCheck} from "../../api/apiClient";

const InputUserPw = ({
                       propLabel = '비밀번호',
                       propOnChange = null,
                     }) => {

  const [error, setError] = useState();

  const onChangePassword = (e) => {
    // console.log(e.target.value);
    const pwReg = /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{10,16}$/
    if (pwReg.test(e.target.value)) {
      setError('');
      propOnChange(e);
    } else {
      setError("10~16자리 이내(영문 대/소문자, 숫자, 특수문자 중 2가지 이상 혼합)");
    }
  };

  return (
      <>
        <Form.Group as={Row} controlId='userPw'>
          <Form.Label column md={3} className={'label text-end fw-bold'}>
            <span className={"text-danger"}>* </span>{propLabel}
          </Form.Label>
          <Col md={9} className={''}>
            <Form.Control
                type="password"
                className={"input input-pw"}
                onChange={onChangePassword}
                required
            />
          </Col>
        </Form.Group>
        {error !== "" ? (
            <Col md={12} className={"error text-center text-danger"}>
              {error}
            </Col>
        ) : ("")}
      </>
  );
};

export default InputUserPw;